import { Injectable } from "@angular/core"
import { GoogleAnalyticsService } from "../../../core/services/google-analytics-events-service"
import { ErrorMessages } from "../../../shared/enum/error-messages"
import { ToastrService } from "ngx-toastr"
import { environment } from "src/environments/environment"

type PropertiesDictionary = { [propertyName: string]: string }

@Injectable({
  providedIn: "root",
})
export class ErrorHandlerService {
  constructor(
    private googleAnalyticsService: GoogleAnalyticsService,
    private toastr: ToastrService,
    private errorMessages: ErrorMessages
  ) {}

  handle =
    (eventCategory?: string, eventAction?: string, eventLabel?: string) =>
    (err) => {
      if (err.error || err._body) {
        const errorMsg = err.error || JSON.parse(err._body)
        if (err.status === 401 || err.status === 403) {
          window.location.href = environment.endpointSSO.url
        } else if (errorMsg.message != null || errorMsg.message !== undefined) {
          this.toastr.error(``, `${errorMsg.message}`)
        } else if (errorMsg.Message != null || errorMsg.Message !== undefined) {
          this.toastr.error(``, `${errorMsg.Message}`)
        } else {
          this.toastr.error(``, `${this.errorMessages.getServiceDefault()}`)
          if (eventCategory && eventAction && eventLabel) {
            this.googleAnalyticsService.emitEvent(
              eventCategory,
              eventAction,
              eventLabel
            )
          }
        }
      }
    }

  onRequestError(err: any, propertiesDictionary?: PropertiesDictionary) {
    if (!err) return
    const statusCode = err.status

    switch (statusCode) {
      case 400:
        return this._badRequestHandler(err, propertiesDictionary)
      case 401:
      case 403:
        return this._invalidTokenHandler(err, propertiesDictionary)
      case 500:
        this._genericHandler(err, propertiesDictionary)
    }
  }

  private _genericHandler(err, propertiesDictionary?: PropertiesDictionary) {
    this.toastr.error("", this.errorMessages.getServiceDefault())
  }

  private _badRequestHandler(err, propertiesDictionary?: PropertiesDictionary) {
    const properties = err.error

    if (!properties || Object.getOwnPropertyNames(properties).length === 0)
      return this._genericHandler(err, propertiesDictionary)

    for (const property in properties) {
      const errorMessages = properties[property]
      const fieldName = (
        (propertiesDictionary ? propertiesDictionary[property] : undefined) ||
        property
      ).toUpperCase()

      if (errorMessages && errorMessages.length > 0) {
        for (const errorMessage of errorMessages) {
          this.toastr.error(errorMessage, fieldName)
        }
      } else {
        this.toastr.error(this.errorMessages.getServiceDefault(), fieldName)
      }
    }
  }

  private _invalidTokenHandler(
    err,
    propertiesDictionary?: PropertiesDictionary
  ) {
    this.toastr.error("", this.errorMessages.getSessionExpiredRedirect())

    requestAnimationFrame(
      () =>
        void requestAnimationFrame(
          () => void (window.location.href = environment.endpointSSO.url)
        )
    )
  }
}
